import React from 'react';
import { useAppSelector } from '../app/hooks';
import getConfig from '../selectors/getConfig';
import combineStyles from '../utils/combineStyles';
import getThemeLookup from '../selectors/getThemeLookup';
import { TEXT_PROPERTIES } from '../utils/theme';
import { OrderingHooks } from 'polygon-ordering';
import getProfile from '../selectors/getProfile';
import Text from '../components/Text';

const { useFormattedCurrency } = OrderingHooks;

const MemberBalance = ({
  amount,
  label,
  isCurrency,
}: {
  amount: number;
  label: string;
  isCurrency?: boolean;
}) => {
  const profile = useAppSelector(getProfile);
  const loyaltyTiers = useAppSelector(state => state.loyaltyTiers);
  const tier = loyaltyTiers?.filter(tier => tier.tierName === profile?.loyaltyTierName)[0];
  const enableTieredLoyalty = useAppSelector(state => state.config.enableTieredLoyalty);
  const p = useAppSelector(getThemeLookup);
  const config = useAppSelector(getConfig);

  const formattedCurrency = useFormattedCurrency({ cents: amount, hideZeroCents: true });

  const amountStyle = combineStyles(
    styles.amount,
    p('accountBalanceAmount', TEXT_PROPERTIES),
    enableTieredLoyalty && { color: tier?.tierTextColour },
  );

  const getDisplayAmount = () => {
    if (isCurrency) {
      return formattedCurrency;
    }

    if (config.displayPointsAsWholeNumber) {
      return Math.floor(amount);
    }

    return amount;
  };

  return (
    <div style={styles.mainContainer}>
      <div style={amountStyle}>{getDisplayAmount()}</div>
      <Text
        style={combineStyles(
          styles.label,
          p('accountBalanceLabel', TEXT_PROPERTIES),
          enableTieredLoyalty && { color: tier?.tierTextColour },
        )}
      >
        {label}
      </Text>
    </div>
  );
};

const styles: Styles = {
  mainContainer: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    textAlign: 'center',
  },
  amount: {
    textAlign: 'center',
    lineHeight: '100%',
    marginBottom: 10,
  },
  label: {
    textAlign: 'center',
  },
};

export default MemberBalance;
